import { type ToastOptions, toast } from 'react-toastify';

import ToastBody from '@components/common/Toast/ToastBody';
import style from '@components/common/Toast/style.module.scss';

type ToasterVariant = 'success' | 'info' | 'error';

interface IProps {
  variant: ToasterVariant;
  message: string;
  options?: ToastOptions;
}

export const showToast = ({ variant, message, options }: IProps) => {
  return toast(ToastBody, {
    data: {
      message,
      variant,
    },
    closeButton: false,
    className: style.toast,
    ...options,
  });
};
